// Material UI components
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";
import {
    getModalSx,
    getCardSx,
    getCloseButtonSx,
    getImageBoxSx
} from "./ImageModalRoot";

export default function ImageModal({
    mediaURL,
    open,
    onClose,
    isLoading = false,
    alt: altText,
}) {
    // Styles
    const modalStyle = getModalSx();
    const cardStyle = getCardSx(open, isLoading);
    const closeButtonStyle = getCloseButtonSx();
    const imageBoxStyle = getImageBoxSx();

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="image-modal-title"
            aria-describedby="image-modal-description"
            sx={modalStyle}
        >
            <Card sx={cardStyle}>

                <IconButton
                    onClick={onClose}
                    sx={closeButtonStyle}
                >
                    <CloseIcon />
                </IconButton>

                {isLoading ? (
                    <MDBox 
                    display="flex" 
                    justifyContent="center" 
                    alignItems="center" 
                    height="80vh"
                    width="80vw"
                    >
                        <CircularProgress />
                    </MDBox>
                ) : (
                    <MDBox
                        component="img"
                        src={mediaURL}
                        alt={altText || "Modal Image"}
                        sx={imageBoxStyle}
                    />
                )}

            </Card>
        </Modal>
    )
}